// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__3n_O2","slide-in-bottom":"Menu_slide-in-bottom__1V8QH","menuItem":"Menu_menuItem__2g2nF"};